const shouldShowOnboarding = (key: string): boolean => {
  const lastShown = localStorage.getItem(key);
  const currentTime = Date.now();

  if (!lastShown) {
    localStorage.setItem(key, currentTime.toString());
    return true;
  }

  let lastShownTime = parseInt(lastShown, 10);

  if (lastShownTime > currentTime) {
    console.warn("El timestamp guardado es del futuro. Corrigiendo...");
    lastShownTime = currentTime - 25 * 60 * 60 * 1000; 
    localStorage.setItem(key, lastShownTime.toString());
  }

  const hoursPassed = (currentTime - lastShownTime) / (1000 * 60 * 60);

  if (hoursPassed >= 24) {
    localStorage.setItem(key, currentTime.toString());
    return true;
  }

  return false;
};



export {
  shouldShowOnboarding
}
